import { createFileRoute } from '@tanstack/react-router'

import { ReportPage } from '@/components/reports/report-page'
import { GeographyTab } from '@/components/reports/geography-tab'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/geography',
)({
    component: GeographyReportPage,
})

function GeographyReportPage() {
    return (
        <ReportPage title={m.report_page_title_geography()}>
            <GeographyTab />
        </ReportPage>
    )
}
